import styled from 'styled-components';

export const StyledBodyContainer = styled.div`
    background-color: ${({ theme }) => theme.tokens.BaseColorWhite};
    min-height: 100vh;
`;
